export default __webpack_public_path__ + "static/media/EM1670.34I-39275_-23275_0.e6fcbd98.jpg";